import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import RoofReplacement from "@/pages/services/RoofReplacement";

export const Route = createFileRoute("/_site/services/roof-replacement")({
  head: () => ({
    ...seo({
      title: "Roof Replacement in Minnesota | Kodiak Structures & Exteriors",
      description:
        "Expert roof replacement in Blaine, Plymouth, Woodbury and throughout Minnesota. Premium materials, licensed contractors, free estimates.",
      path: "/services/roof-replacement",
    }),
  }),
  component: RoofReplacement,
});
